import React from 'react';
import { Wrench, RefreshCw, HardHat, ArrowRight } from 'lucide-react';
export function ProjectTypes() {
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-800" data-mp="1ugwlv4fzf1ix">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-801" data-mp="1ggc2o765n3ow">
        <div className="text-center mb-16 anim-on-scroll" data-id="element-802" data-mp="1ghx1wa3ezat3">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-803" data-mp="1ledpn36pbn5n">
            What Kind of Commercial Glass Project Do You Need?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-804" data-mp="2e3kwqqk81l2i">
          {/* Card 1 */}
          <div className="bg-slate-50 rounded-lg p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden scroll-fade-up" style={{
          animationDelay: '0s'
        }} data-id="element-805" data-mp="2e5nj90m60w2h">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-806" data-mp="2s3c3c68erz6h"></div>
            <Wrench className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-807" data-mp="2wv3xeqqrwn1d" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-808" data-mp="1w8iz28ctoq8">
              Storefront or Door Repair
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-normal" data-id="element-809" data-mp="3t55zdk6hy9ac">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-810" data-mp="5yvjdrj3chz1">
              {['Broken storefront glass', 'Damaged commercial door glass', 'Cracked business window glass', 'Failed insulated glass units', 'Existing building service or maintenance'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-811" data-mp="tnera5y8asql" data-mpi={i}>
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-812" data-mp="pnxl1aaz9rkd"></div>
                  <span data-id="element-813" data-mp="2vgm7dhlo1edj">{item}</span>
                </li>)}
            </ul>
            <a href="#quote" className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-814" data-mp="2rer1dzssictf">
              Repair My Storefront Glass
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-815" data-mp="14ahk27buhqrz" />
            </a>
          </div>

          {/* Card 2 */}
          <div className="bg-navy-900 rounded-lg p-8 border border-navy-800 flex flex-col h-full relative overflow-hidden shadow-xl transform md:-translate-y-4 scroll-fade-up" style={{
          animationDelay: '0.1s'
        }} data-id="element-816" data-mp="1989d54o87ixr">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-600 rounded-bl-full -mr-4 -mt-4 opacity-20" data-id="element-817" data-mp="1n2sinozgv2ka"></div>
            <RefreshCw className="w-10 h-10 text-primary-400 mb-6 relative z-10" data-id="element-818" data-mp="1s2y1cfnrdeq8" />
            <h3 className="kosins-heading text-3xl text-white mb-4" data-id="element-819" data-mp="1x216e03qnky7">
              Renovation or Replacement
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-400 uppercase tracking-normal" data-id="element-820" data-mp="3ljudkxccq26y">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-821" data-mp="3hh5zob8s6534">
              {['Business window replacement', 'Storefront upgrades', 'Office remodels', 'Glass wall installation', 'Lobby or entryway improvements'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300" data-id="element-822" data-mp="91mcntypdiwi" data-mpi={i}>
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-400 mt-2 shrink-0" data-id="element-823" data-mp="44njpeqrzhzw"></div>
                  <span data-id="element-824" data-mp="3vgyqs7o7ynbm">{item}</span>
                </li>)}
            </ul>
            <a href="#quote" className="w-full py-3 px-4 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-500 transition-colors flex items-center justify-center gap-2 group" data-id="element-825" data-mp="3qjp24u8nmfou">
              Plan a Commercial Glass Upgrade
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-826" data-mp="7jnrc776tipw" />
            </a>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-50 rounded-lg p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden scroll-fade-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-827" data-mp="bn3l8vrvh4yw">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-828" data-mp="qax18hkve9i0"></div>
            <HardHat className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-829" data-mp="va1b7afmcb9e" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-830" data-mp="gl51za1tss77">
              Contract Glazing
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-normal" data-id="element-831" data-mp="liwv27e7ikcz">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-832" data-mp="197g3qo164z5l">
              {['New construction', 'Tenant build-outs', 'Exterior glazing systems', 'Curtain walls and storefront systems', 'Projects needing bid coordination, fabrication and installation'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-833" data-mp="37hx2a0hzss5o" data-mpi={i}>
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-834" data-mp="33gv3fkrzmi48"></div>
                  <span data-id="element-835" data-mp="2frahqu4g96r9">{item}</span>
                </li>)}
            </ul>
            <a href="#quote" className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-836" data-mp="2asz7wje5mw91">
              Request a Contract Glazing Bid
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-837" data-mp="41q9ip148fbo" />
            </a>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto anim-on-scroll" data-id="element-838" data-mp="3v814q4jg2lv3">
          <p className="text-sm text-slate-500 bg-slate-100 py-3 px-6 rounded-full inline-block" data-id="element-839" data-mp="2svxv3ex47j8p">
            Kosin’s Glass can review your scope, photos, measurements, drawings,
            timeline and location to recommend the right next step.
          </p>
        </div>
      </div>
    </section>;
}